﻿import * as $ajax from './_ajax'
import * as $form from './_form'
import * as $help from './help'
import * as $helpers from './_helpers'
import * as $modal from './_modal'
import * as $msg from './_msg'
import * as $notifications from './_notifications'
import * as $ownocom from './owner.notes.common'
import * as $propnocom from './property.notes.common'
import * as $ubh from './_uniformboxheights'

export module noteslist {
    export interface IInitOptions {
        pageName: string
        pagePrefix: string
    }

    var options: IInitOptions
    var rowHeightObject

    export let currentPageOwner: number = 1
    export let currentPageProperty: number = 1

    let ownerSortId: number = -1
    let ownerSortAsc: boolean = true

    let propSortId: number = -1
    let propSortAsc: boolean = true

    export function init($options: IInitOptions): void {
        options = $.extend(true, {}, $options)

        $help.tooltips.initializeTooltips($('.' + options.pageName))

        $('#' + options.pagePrefix + '-agare-submit').click(function () {
            getFilteredListOwner(1)
        })

        $('#' + options.pagePrefix + '-agare-reset').click(function () {
            resetSearchOwner()
        })

        $('#' + options.pagePrefix + '-fastighet-submit').click(function () {
            getFilteredListProperty(1)
        })

        $('#' + options.pagePrefix + '-fastighet-reset').click(function () {
            resetSearchProperty()
        })

        rowHeightObject = new $ubh.uniformBoxHeights({
            listElementsSelector: '.' + options.pagePrefix + '-row .bcfla-box',
        })
    }

    function setRowHeight(): void {
        if (rowHeightObject) rowHeightObject.setHeights()
    }

    function resetSearchOwner(): void {
        $('#' + options.pagePrefix + '-agare-created-from').val('')
        $('#' + options.pagePrefix + '-agare-created-to').val('')
        $('#' + options.pagePrefix + '-agare-returndate-from').val('')
        $('#' + options.pagePrefix + '-agare-returndate-to').val('')
        $('#' + options.pagePrefix + '-agare-string').val('')
        $('#' + options.pagePrefix + '-agare-type button').addClass('bcfla-checked')
        getFilteredListOwner(1, { sortId: -1, sortAsc: true })
    }

    export function getFilteredListOwner(page: number = -1, extraData?: { sortId: number; sortAsc: boolean }): void {
        if (page <= 0) page = currentPageOwner
        if (extraData?.sortId != null) ownerSortId = extraData.sortId
        if (extraData?.sortAsc != null) ownerSortAsc = extraData.sortAsc

        $ajax.post({
            loadingText: 'Hämtar lista...',
            url: '/Note/NotesOwnerList',
            data: {
                page: page,
                sort: ownerSortId,
                asc: ownerSortAsc,
                createdFrom: $('#' + options.pagePrefix + '-agare-created-from').val(),
                createdTo: $('#' + options.pagePrefix + '-agare-created-to').val(),
                returnFrom: $('#' + options.pagePrefix + '-agare-returndate-from').val(),
                returnTo: $('#' + options.pagePrefix + '-agare-returndate-to').val(),
                text: $('#' + options.pagePrefix + '-agare-string').val(),
                types: $form.getCheckboxlistValues($('#' + options.pagePrefix + '-agare-type')).join(','),
                organization: $form.getCheckboxlistValues($('#' + options.pagePrefix + '-agare-entireorganization'))[0],
            },
            dataType: 'html',
            success: function (res) {
                $('#' + options.pagePrefix + '-agare-list-plh').html(res)
                currentPageOwner = page
                setRowHeight()
            },
        })
    }

    function resetSearchProperty(): void {
        $('#' + options.pagePrefix + '-fastighet-created-from').val('')
        $('#' + options.pagePrefix + '-fastighet-created-to').val('')
        $('#' + options.pagePrefix + '-fastighet-string').val('')
        getFilteredListProperty(1, { sortId: -1, sortAsc: true })
    }

    export function getFilteredListProperty(page: number = -1, extraData?: { sortId: number; sortAsc: boolean }): void {
        if (page <= 0) page = currentPageProperty
        if (extraData?.sortId != null) propSortId = extraData.sortId
        if (extraData?.sortAsc != null) propSortAsc = extraData.sortAsc

        $ajax.post({
            loadingText: 'Hämtar lista...',
            url: '/Note/NotesPropertyList',
            data: {
                page: page,
                sort: propSortId,
                asc: propSortAsc,
                createdFrom: $('#' + options.pagePrefix + '-fastighet-created-from').val(),
                createdTo: $('#' + options.pagePrefix + '-fastighet-created-to').val(),
                text: $('#' + options.pagePrefix + '-fastighet-string').val(),
                organization: $form.getCheckboxlistValues(
                    $('#' + options.pagePrefix + '-fastighet-entireorganization')
                )[0],
            },
            dataType: 'html',
            success: function (res) {
                $('#' + options.pagePrefix + '-fastighet-list-plh').html(res)
                currentPageProperty = page
                setRowHeight()
            },
        })
    }
}

export module ownerlist {
    export interface IInitOptions {
        pageName: string
        pagePrefix: string
        sortId: number
        sortAsc: boolean
    }

    var options: IInitOptions
    let sortId: number = -1
    let sortAsc: boolean = true

    export function init($options: IInitOptions): void {
        options = $.extend(true, {}, $options)

        sortId = options.sortId
        sortAsc = options.sortAsc

        $('#' + options.pageName + ' .bcfla-th-sortable').click(function () {
            setSort(parseInt($(this).attr('data-sortid')), $(this).attr('data-sortasc'))
            noteslist.getFilteredListOwner(1, { sortId, sortAsc })
        })

        $('#' + options.pagePrefix + '-list .' + options.pagePrefix + '-listitem-footer-icons .glyphicon-ok').click(
            function () {
                toggleCompleted($(this).attr('data-id'))
            }
        )

        $('#' + options.pagePrefix + '-list .' + options.pagePrefix + '-listitem-footer-icons .glyphicon-remove').click(
            function () {
                deleteNote($(this).attr('data-id'))
            }
        )

        $('#' + options.pagePrefix + '-list .' + options.pagePrefix + '-listitem-footer-icons .glyphicon-pencil').click(
            function () {
                $modal.load(
                    '/Note/EditOwner',
                    { id: $(this).attr('data-id'), callback: 'bcfla.note.noteslist.getFilteredListOwner' },
                    false
                )
            }
        )

        $('#' + options.pagePrefix + '-list a').click(function (e) {
            var url = $(this).attr('data-link')
            $modal.load(url, {}, false, true, true)
            e.preventDefault()
        })
    }

    function toggleCompleted(id: string): void {
        $ownocom.toggleCompleted(id, function () {
            noteslist.getFilteredListOwner(noteslist.currentPageOwner)
        })
    }

    function deleteNote(id: string): void {
        $ownocom.deleteNote(id, function () {
            noteslist.getFilteredListOwner(noteslist.currentPageOwner)
        })
    }

    function setSort(newSort: number, newAsc: string): void {
        if (newSort != sortId) {
            sortId = newSort
            sortAsc = newAsc == 'true'
        } else {
            sortAsc = !sortAsc
        }
    }
}

export module propertylist {
    export interface IInitOptions {
        pageName: string
        pagePrefix: string
        sortId: number
        sortAsc: boolean
    }

    var options: IInitOptions
    let sortId: number = -1
    let sortAsc: boolean = true

    export function init($options: IInitOptions): void {
        options = $.extend(true, {}, $options)

        sortId = options.sortId
        sortAsc = options.sortAsc

        $('#' + options.pageName + ' .bcfla-th-sortable').click(function () {
            setSort(parseInt($(this).attr('data-sortid')), $(this).attr('data-sortasc'))
            noteslist.getFilteredListProperty(1, { sortId, sortAsc })
        })

        $('#' + options.pagePrefix + '-list .' + options.pagePrefix + '-listitem-footer-icons .glyphicon-remove').click(
            function () {
                deleteNote($(this).attr('data-id'))
            }
        )

        $('#' + options.pagePrefix + '-list .' + options.pagePrefix + '-listitem-footer-icons .glyphicon-pencil').click(
            function () {
                $modal.load(
                    '/Note/EditProperty',
                    { id: $(this).attr('data-id'), callback: 'bcfla.note.noteslist.getFilteredListProperty' },
                    false
                )
            }
        )

        $('#' + options.pagePrefix + '-list a').click(function (e) {
            var url = $(this).attr('data-link')
            $modal.load(url, {}, false, true, true)
            e.preventDefault()
        })
    }

    function deleteNote(id: string): void {
        $propnocom.deleteNote(id, function () {
            noteslist.getFilteredListProperty(noteslist.currentPageProperty)
        })
    }

    function setSort(newSort: number, newAsc: string): void {
        if (newSort != sortId) {
            sortId = newSort
            sortAsc = newAsc == 'true'
        } else {
            sortAsc = !sortAsc
        }
    }
}

export module editowner {
    export interface IInitOptions {
        pageName: string
        pagePrefix: string
        noteId: number
        callback: any
    }

    var options: IInitOptions

    export function init($options: IInitOptions): void {
        options = $.extend(true, {}, $options)

        $helpers.partialPageInit($('#' + options.pageName))

        $('.' + options.pagePrefix + '-save').click(function () {
            $ajax.post({
                loadingText: 'Sparar...',
                url: '/Note/EditOwnerSave',
                data: {
                    id: options.noteId,
                    text: $('.' + options.pagePrefix + '-note').val(),
                    returnat: $('.' + options.pagePrefix + '-returnat').val(),
                    visibility: $form.getCheckboxlistValues($('.' + options.pagePrefix + '-visibility'))?.[0] || '1',
                },
                success: function (res) {
                    if (res.Ok) {
                        $notifications.load()
                        $modal.hide()
                        options.callback()
                    } else {
                        $msg.showError(res.Message)
                    }
                },
            })
        })

        $('.' + options.pagePrefix + '-close').click(function () {
            $modal.hide()
        })
    }
}

export module editproperty {
    export interface IInitOptions {
        pageName: string
        pagePrefix: string
        noteId: number
        callback: any
    }

    var options: IInitOptions

    export function init($options: IInitOptions): void {
        options = $.extend(true, {}, $options)

        $helpers.partialPageInit($('#' + options.pageName))

        $('.' + options.pagePrefix + '-save').click(function () {
            $ajax.post({
                loadingText: 'Sparar...',
                url: '/Note/EditPropertySave',
                data: {
                    id: options.noteId,
                    text: $('.' + options.pagePrefix + '-note').val(),
                    visibility: $form.getCheckboxlistValues($('.' + options.pagePrefix + '-visibility'))?.[0] || '1',
                },
                success: function (res) {
                    if (res.Ok) {
                        $notifications.load()
                        $modal.hide()
                        options.callback()
                    } else {
                        $msg.showError(res.Message)
                    }
                },
            })
        })

        $('.' + options.pagePrefix + '-close').click(function () {
            $modal.hide()
        })
    }
}
